import { useAuthStore } from '@/stores/auth.js';

/**
 * Hook for permission checking in components
 * @returns {Object} Permission checking utilities
 */
export function usePerm() {
  const user = useAuthStore((s) => s.user);
  const storeHasPerm = useAuthStore((s) => s.hasPerm);
  const storeHasAllPerms = useAuthStore((s) => s.hasAllPerms);
  const storeHasAnyPerm = useAuthStore((s) => s.hasAnyPerm);

  // Wrap permission checks to grant admins full access
  const hasPerm = (code) => {
    if (user?.role === 'admin') return true;
    return storeHasPerm(code);
  };

  const hasAllPerms = (...codes) => {
    if (user?.role === 'admin') return true;
    return storeHasAllPerms(...codes);
  };

  const hasAnyPerm = (...codes) => {
    if (user?.role === 'admin') return true;
    return storeHasAnyPerm(...codes);
  };

  return {
    /**
     * Check if user has a specific permission (admin always returns true)
     * @param {string} code - Permission code (e.g., 'employees.read')
     * @returns {boolean}
     */
    hasPerm,

    /**
     * Check if user has ALL specified permissions (admin always returns true)
     * @param {...string} codes - Permission codes
     * @returns {boolean}
     */
    hasAllPerms,

    /**
     * Check if user has ANY specified permission (admin always returns true)
     * @param {...string} codes - Permission codes
     * @returns {boolean}
     */
    hasAnyPerm,
  };
}
